/* eslint-disable */
import Cookies from 'js-cookie';

const COOKIE_NAME = '__baxter-brewing-announcement';

function init() {

  let $bar = $('.announcement-bar');
  let $toggle = $('.announcement-bar-toggle');

  if (Cookies.get(COOKIE_NAME) != 1 && $bar.length) {

    setTimeout(function() {
      $bar.addClass('announcement-bar--in');

      document.body.classList.add('has-announcement-bar');
    }, 250);

  }

  if ($bar.length > 0) {
    $toggle.on('click', function() {
      $bar.removeClass('announcement-bar--in');

      document.body.classList.remove('has-announcement-bar');

      Cookies.set(COOKIE_NAME, 1, {
        expires: 1,
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', init);




// WEBPACK FOOTER //
// ./scripts/lib/announcement-bar.js